import { get } from '@Lib/request'
import { path } from './url'



const { newCarApiV3 } = path
// 特辑详情
export async function fetchSpecialAlbumsss(params?: any) {
    return await get<any>(`${newCarApiV3}/collection/details`, params)
}
// 查询特辑入口开关状态
export async function fetchSpecialSwitch() {
    return await get<any>(`${newCarApiV3}/collection/switch`)
}
// 特辑列表页
export async function fetchSpecialList() {
    return await get<{
        list: any
    }>(`${newCarApiV3}/collection/list`)
}
